/* Per-link Best Sellers product pin. Only acts on page one with valid product IDs. */
(() => {
  async function applyProductPin() {
    const params = new URLSearchParams(window.location.search);
    if (!/^pin-\d+$/.test(params.get('handle') || '') || Number(params.get('page') || 1) !== 1) return;
    const ids = [...new Set((params.get('ids') || '').split(',').map(id => id.trim()).filter(id => /^\d{8,20}$/.test(id)))].slice(0, 8);
    if (!ids.length) return;

    const section = document.querySelector('.facest-filters-section[data-view="collection"]');
    const grid = section?.querySelector('[data-product-container]');
    if (!grid) return;
    const found = new Map();
    const collect = root => root.querySelectorAll('[data-product-container] > [data-pin-product-id]').forEach(card => {
      const id = card.dataset.pinProductId;
      if (ids.includes(id) && !found.has(id)) found.set(id, card);
    });
    collect(section);

    const pages = Math.min(Number(grid.dataset.totalPages) || 1, 30);
    for (let page = 2; page <= pages && found.size < ids.length; page++) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', section.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) break;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        collect(html);
      } catch (error) {
        console.warn('Product Pin could not load collection page', page, error);
        break;
      }
    }
    for (const id of [...ids].reverse()) {
      const card = found.get(id);
      if (card) grid.prepend(card);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyProductPin, { once: true });
  } else {
    applyProductPin();
  }
})();
